import * as R from "ramda";

export const getAmount = R.prop("amount");
// eslint-disable-next-line no-return-assign
export const sumCosts = R.reduce((total, c) => (total += getAmount(c)), 0);
export const getCostForFeeID = (costs, id) => R.find(R.propEq(id, "fee_id"), costs);
